'use client';
import styled, { css } from 'styled-components';

import { device, hexToRGB, typography } from '@/styles/helpers';

export const ScGamePageContainer = styled.div<{
  isFullScreen: boolean;
  isMobile: boolean;
  isAuthenticated: boolean;
  isEstonia: boolean;
  isUnloggedCard?: boolean;
}>`
  height: calc(100vh - 156px);
  height: calc(100dvh - 156px);
  width: calc(100vw - 34px);
  padding: 0 40px ${({ isMobile }) => (isMobile ? '32px' : '16px')};
  display: flex;
  position: relative;
  flex-direction: column;
  margin-top: ${({ isMobile }) => (isMobile ? '-24px' : '-16px')};

  ${({ isFullScreen, isMobile }) =>
    isFullScreen &&
    !isMobile &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      margin: 0;
      z-index: 120;
      height: 100vh;
      height: 100dvh;
      padding: 24px 16px;
      width: calc(100vw - 54px);

      .bg {
        background-color: black;
        position: fixed;
        inset: 0;
      }
    `}

  ${({ isMobile, isFullScreen, isAuthenticated }) =>
    isMobile &&
    isFullScreen &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      margin: 0;
      width: 100%;
      height: 100vh;
      height: 100dvh;
      padding: 0 0 ${isAuthenticated ? 0 : '72px'};
      z-index: 120;
    `}

  ${({ isMobile, isFullScreen, isUnloggedCard }) =>
    isMobile &&
    !isFullScreen &&
    css`
      position: relative;
      width: 100%;
      height: ${isUnloggedCard ? 'auto' : '410px'};
      padding: 0 16px;
    `}
`;

export const ScGamePage = styled.div<{
  isMobile: boolean;
  isFullScreen: boolean;
}>`
  height: 55vw;
  width: calc(150vh - 56px);
  width: calc(150dvh - 56px);
  max-height: 100%;
  max-width: 100%;
  margin: auto;

  ${({ isMobile }) =>
    isMobile &&
    css`
      width: 100%;
      height: 100%;
    `}

  ${({ isFullScreen, isMobile }) =>
    isFullScreen &&
    !isMobile &&
    css`
      width: calc(175vh - 56px);
      width: calc(175dvh - 56px);
    `}
`;

export interface ScGameCardProps {
  isFullScreen: boolean;
  isAuthenticated?: boolean;
  isMobile: boolean;
}

export const ScGameCard = styled.div<ScGameCardProps>`
  position: relative;
  height: 100%;
`;

interface ScGameContainerProps {
  isFullScreen: boolean;
  withTournamentBanner: boolean;
  isDimming?: boolean;
  isAddons?: boolean;
  isMobile: boolean;
}

export const ScGameContainer = styled.div<ScGameContainerProps>`
  background-color: ${({ theme }) => theme.blackColor};
  z-index: 0;
  position: relative;

  .close-btn__wrapper {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
  }

  ${({ isFullScreen }) =>
    isFullScreen
      ? css`
          inset: 0;
          position: absolute;
          width: auto;
          height: auto;
          padding-top: 0;
          @media (${device.mobile}) {
            right: 0;
            margin-bottom: 0;
          }
        `
      : css`
          position: relative;
          width: 100%;
          height: 100%;
        `};

  ${({ theme, isDimming }) =>
    isDimming &&
    css`
      &:after {
        display: block;
        content: '';
        position: absolute;
        inset: 0;
        z-index: 11;
        border-radius: 16px;
        background: ${hexToRGB(theme.blackColor, 0.7)};
      }
    `}

  & > .loading {
    position: absolute;
    inset: 0;
    z-index: 11;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${({ isMobile }) => (isMobile ? '0px' : '16px')};
    overflow: hidden;
  }

  & > iframe {
    position: absolute;
    left: 0;
    top: ${({ withTournamentBanner }) => (withTournamentBanner ? '24px' : 0)};
    width: 100%;
    height: ${({ withTournamentBanner }) =>
      withTournamentBanner ? 'calc(100% - 24px)' : '100%'};
    border-radius: ${({ isMobile }) => (isMobile ? '0px' : '16px')};
    overflow: hidden;
  }
`;

export const ScGameCardFooter = styled.footer`
  padding: 16px 18px;
  background-color: ${({ theme }) => theme.blackColor};
  position: fixed;
  inset: auto 0 0;
`;

export const ScGameTitle = styled.h1`
  display: flex;
  align-items: center;
  gap: 8px;
  width: calc(150vh - 56px);
  max-width: 100%;
  color: ${({ theme }) => theme.whiteColor};
  margin: 0 auto 16px;

  .back {
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
    color: ${({ theme }) => theme.whiteColor};
    transform: rotate(180deg);
    flex-shrink: 0;
  }

  .title {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${typography.headline2mobile};
  }

  @media (${device.mobile}) {
    width: 100%;
    margin: 0 0 4px;
    padding: 0;
    .title {
      ${typography.body1bold}
    }
  }
`;
